export const clearDescription = (text: string) => {
  // 1) Elimina bloques de código ```...```
  text = text.replace(/```[\s\S]*?```/g, "");

  // 2) Elimina código inline `...`
  text = text.replace(/`([^`]+)`/g, "$1");

  // 3) Convierte imágenes ![alt](url) → alt
  text = text.replace(/!\[([^\]]*)\]\([^\)]+\)/g, "$1");

  // 4) Convierte enlaces [texto](url) → texto
  text = text.replace(/\[([^\]]+)\]\([^\)]+\)/g, "$1");

  // 5) Quita encabezados #, ##, ### al inicio de línea
  text = text.replace(/^\s{0,3}#{1,6}\s*/gm, "");

  // 6) Quita blockquotes > al inicio de línea
  text = text.replace(/^\s{0,3}>\s?/gm, "");

  // 7) Quita listas no ordenadas y ordenadas
  text = text.replace(/^\s{0,3}([-*+])\s+/gm, "");
  text = text.replace(/^\s{0,3}\d+\.\s+/gm, "");

  // 8) Elimina negritas, cursivas y tachado
  text = text.replace(/(\*\*|__)(.*?)\1/g, "$2");
  text = text.replace(/(\*|_)(.*?)\1/g, "$2");
  text = text.replace(/~~(.*?)~~/g, "$1");

  // 9) Elimina tablas separadores de cabecera (líneas con ---)
  text = text.replace(/^\|?(\s*[:-]+[-| :]*\n?)+\|?/gm, "");

  // 10) Elimina separadores horizontales (---, ***, ___)
  text = text.replace(/^\s{0,3}([-*_]){3,}\s*$/gm, "");

  // ——— Paso nuevo ———
  // 11) Reemplaza cualquier salto de línea (uno o varios) por un único espacio
  text = text.replace(/\r?\n+/g, " ");

  // 12) Colapsa múltiples espacios en uno solo
  text = text.replace(/ {2,}/g, " ");

  // 13) Trim al inicio y fin
  return text.trim();
};